/**
 * App Router Component
 * 
 * This component handles the main application routing
 * and renders the appropriate page based on authentication state.
 */

import React from 'react';
import { useApp } from '../context/AppContext';
import LoginPage from '../pages/LoginPage';
import MainLayout from '../components/layout/MainLayout';

const AppRouter = () => {
  const { state } = useApp();

  // Show loading screen during authentication check
  if (state.authLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>جاري التحميل...</p>
      </div>
    );
  }

  if (!state.isAuthenticated) {
    return <LoginPage />;
  }

  return <MainLayout />;
};

export default AppRouter;
